import './App.css';
import { Helmet } from 'react-helmet';
import { useLocale } from 'app/hooks/useLocale';
import { favicon } from 'app/util/constants';
import Loading from 'app/components/loading/loading';
import { Alert } from 'app/components/alert/alert';
import useApp from './useApp';
import { useErrorHandler } from 'app/pages/frames/hooks/useErrorHandler';
import { useCardinalScript } from 'app/hooks/useCardinalScript';
import { useEffect } from 'react';
import {
  initializeDatadogLogs,
  initializeDatadogRum,
  initializeFingerprint,
  initializeGoogleAnalytics,
} from 'app/hooks/useLoggerServices';

function App() {
  useLocale();
  useApp();
  useCardinalScript();
  const { error, isLoading } = useErrorHandler();

  useEffect(() => {
    initializeDatadogRum();
    initializeDatadogLogs();
    initializeFingerprint();
    initializeGoogleAnalytics();
  }, []);

  return (
    <div className='App'>
      <Helmet>
        <link rel='icon' href={favicon} />
      </Helmet>
      <div className='card'>
        {!error && isLoading && <Loading />}
        {error && <Alert type='error'>{error?.message}</Alert>}
      </div>
    </div>
  );
}

export default App;
